import { request } from 'Apiv2/handleRequest';

const BASE_URL = '/place_contacts';

export const buildBody = ({
  contactType,
  title,
  email,
  phone,
  extension,
  instructions,
  universal,
  visibility,
  carePlanTemplateIds,
}) => ({
  place_contact: {
    contact_type: contactType,
    title,
    email,
    phone,
    extension,
    instructions,
    universal,
    care_plan_template_ids: carePlanTemplateIds,
    visibility: {
      // getting the values in an off chance they come in undeclared
      patients_and_support_teams: !!visibility.patientsAndSupportTeams,
      your_health_team: !!visibility.yourHealthTeam,
      invited_health_teams: !!visibility.invitedHealthTeams,
    },
  },
});

const defaultRedirect = (url) => window.location.assign(url);

const savePlaceContactWrapper = (
  requestProvider = request,
  buildBodyProvider = buildBody,
  redirectProvider = defaultRedirect
) => {
  return async (
    { mode, id, ...formValues },
    { setIsLoading, setSaveError }
  ) => {
    try {
      setIsLoading(true);
      setSaveError(false);

      const body = buildBodyProvider(formValues);
      const inEditMode = mode === 'edit';
      const url = inEditMode ? `${BASE_URL}/${id}` : BASE_URL;
      const method = inEditMode ? 'PATCH' : 'POST';

      const response = await requestProvider(url, method, body);

      if (response.status !== 200) {
        throw new Error('Request did not process / Server error');
      }

      redirectProvider(BASE_URL);
      return;
    } catch (error) {
      setIsLoading(false);
      setSaveError(true);
      return;
    }
  };
};

export default savePlaceContactWrapper;
